import { render, staticRenderFns } from "./see-ocr.vue?vue&type=template&id=45d06076"
import script from "./see-ocr.vue?vue&type=script&lang=js"
export * from "./see-ocr.vue?vue&type=script&lang=js"
import style0 from "./see-ocr.vue?vue&type=style&index=0&id=45d06076&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports